import { useUserSelector } from './root';

export function useIsUserAgentSelector(): boolean {
  const user = useUserSelector();

  if (!user.data.isAuthenticated) {
    return false;
  }

  return user.data.isAgent && !user.data.isBuilder;
}
